<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <a class="simple-text logo-normal" href="/overview">
        <div class="logo-img-big">
          <img :src="logo" alt="" />
        </div>
      </a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot> </slot>
      <ul class="nav">
        <slot name="links">
          <!-- {{ sidebarLinks }} -->
          <div
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            class=""
          >
            <!-- {{ link.show }} -->
            <!-- -->
            <sidebar-item v-if="link.show" :link="link">
              <div
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                class=""
              >
                <!-- {{ subLink.show }} -->
                <!--  -->
                <sidebar-item v-if="subLink.show" :link="subLink">
                </sidebar-item>
              </div>
            </sidebar-item>
          </div>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import "perfect-scrollbar/dist/css/perfect-scrollbar.css";
import * as sbl from "./../../../sidebarLinks";
export default {
  props: {
    title: {
      type: String,
      default: "Vue PDP Pro",
      description: "Sidebar title",
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: "Sidebar background color (white|brown|black)",
    },
    activeColor: {
      type: String,
      default: "warning",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar active text color (primary|info|success|warning|danger)",
    },
    logo: {
      type: String,
      default: process.env.VUE_APP_FRONTEND + "static/img/logo.png",
      description: "Sidebar Logo",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "Sidebar links. Can be also provided as children components (sidebar-item)",
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this._sbl = sbl.default;
  },
  provide() {
    return {
      autoClose: this.autoClose,
      permissions: null,
      _sbl: null,
    };
  },
  methods: {
    async initScrollBarAsync() {
      let isWindows = navigator.platform.startsWith("Win");
      if (!isWindows) {
        return;
      }
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
  },
  mounted() {
    this.initScrollBarAsync();

    var p = localStorage.getItem("permissions");

    var pr = JSON.parse(p);
    this.permissions = pr.permissions;
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
